<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>{{ tagId ? "Edit" : "Add New" }} Tag</h1>
  </div>
  <div *ngIf="!loading">
    <div class="typeSection" [formGroup]="form">
      <span class="typeLabel">Tag Type</span>
      <mat-radio-group formControlName="type" class="category-radio-group">
        <mat-radio-button value="story">Stories</mat-radio-button>
        <mat-radio-button value="coloring">Coloring Images</mat-radio-button>
        <mat-radio-button value="poster">Posters</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="tagsWrapper">
      <form id="translation" [formGroup]="form">
        <label class="block-pointer">
          <span>Tag Name</span>
          <mat-form-field>
            <input type="text" matInput placeholder="Tag Name *" formControlName="name" maxlength="51" />
            <mat-error *ngIf="form.get('name')?.hasError('required')">Tag name is required</mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('maxlength')">Tag name must not exceed 50
              characters</mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('onlySpecialChars')">
              Tag name must not contain only special characters
            </mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('onlySpaces')">
              Tag name cannot be empty spaces
            </mat-error>
          </mat-form-field>
        </label>
        <label>
          <span>Choose Language</span>
          <mat-form-field>
            <mat-select formControlName="langId" placeholder="Language *">
              <mat-option *ngFor="let lang of languages" [disabled]="isLangSelected(lang.id)" [value]="lang.id">
                {{ lang.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('langId')?.hasError('required')">Language is required</mat-error>
          </mat-form-field>
        </label>
        <div class="category-and-add-row">
          <p class="add-all-text" [style.visibility]="!tagId ? 'visible' : 'hidden'">
            Add all {{ languages.length }} langauges translations
          </p>
          <div [style.visibility]="
            !loading && (isEditing || tagTranslations.length < 5)
              ? 'visible'
              : 'hidden'
          ">
            <button (click)="addTag()" type="button" class="add-button unblock-pointer">
              Add
            </button>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="tagTranslations.length" class="tableWrapper">
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Tag Name</th>
            <th>Language</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tag of tagTranslations; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ tag.tagName }}</td>
            <td>
              {{ getLanguageName(tag.langId) }}
            </td>
            <td>
              <div class="actionWrapper">
                <div *ngIf="tag.langId !== 1" class="actionItem" (click)="removeTag(i)">
                  <img src="../../../assets/images/icons/icon-delete.svg" alt="Delete" />
                </div>
                <div class="actionItem" (click)="editTag(i)">
                  <img src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btnWrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="cmn-next-btn" (click)="saveTags()"
        [disabled]="tagTranslations.length !== languages.length || isSubmitting">
        {{ tagId ? "Update" : "Save" }}
      </button>

    </div>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
</section>
